var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoroi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo-CostCalculator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #4149f6;\n      }\n\n      .st1 {\n        fill: #064b93;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill-rule: evenodd;\n      }\n\n      .st3, .st4 {\n        fill: #004b93;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-CostCalculator1",
    "data-name": "Logo-CostCalculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st1",
    d: "M0,62.3h104v32c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st0",
    d: "M104,62.3H0V10.3C0,4.8,4.5.3,10,.3h84c5.5,0,10,4.5,10,10v52h0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,54v4.7h-3.5v-4.7c-4.2-.3-8.2-1.6-10.4-3.5l1.9-4.3c2.1,1.7,5.3,2.9,8.5,3.2v-8.5c-4.7-1.1-9.7-2.7-9.7-8.6s3.1-8.1,9.7-8.7v-4.8h3.5v4.7c3.1.2,6.3,1.1,8.6,2.6l-1.7,4.3c-2.2-1.3-4.6-2-6.9-2.3v8.6c4.7,1.1,9.8,2.6,9.8,8.5s-3.2,8-9.8,8.7ZM50.5,35.9v-7.5c-3,.5-4.3,2-4.3,3.9s1.8,3,4.3,3.7ZM58.4,45.7c0-2.1-1.9-3.1-4.4-3.8v7.5c3.1-.5,4.4-1.9,4.4-3.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1452",
    className: "st3",
    d: "M18,33.4c1-6.3,3.7-12.2,7.9-17,1.3,1.4,2.7,2.9,4.1,4.2-10,12.1-8.4,30,3.7,40.1,12.1,10,30,8.4,40.1-3.7,10-12.1,8.4-30-3.7-40.1-6.6-5.5-15.3-7.7-23.7-6-1.2-1.7-2.2-3.4-3.2-5.3,18.3-4.8,37.1,6.1,42,24.4,4.8,18.3-6.1,37.1-24.4,42-18.3,4.9-37.1-6.1-42-24.4-1.3-4.7-1.5-9.5-.8-14.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.4,93.7l-4.6-6.6c-.3,0-.6,0-.9,0h-5.1v6.5h-4.2v-22.4h9.2c5.9,0,9.5,3,9.5,8s-1.7,5.9-4.8,7.1l5.2,7.4h-4.5ZM33.8,74.8h-4.9v8.9h4.9c3.6,0,5.5-1.7,5.5-4.5s-1.9-4.4-5.5-4.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.6,84.1c-.9-6.6,3.5-12.1,10.3-13.1,6.9-1,12.6,3.1,13.6,9.7s-3.5,12.1-10.3,13.1c-6.9,1-12.6-3.2-13.6-9.7ZM66.4,81.3c-.6-4.5-4.4-7.3-8.9-6.7s-7.3,4.4-6.7,8.9,4.4,7.3,8.9,6.7,7.3-4.4,6.7-8.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.1,71.3h4.2v22.4h-4.2v-22.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47,13.2l-8.3-.5c-.4,0-.6-.3-.5-.7h0c0,0,0-.2,0-.2l3.2-7.9c.2-.4.8-.4,1,0l2.6,4.5,2.5,4c.2.4,0,.9-.5.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoroi);
export default __webpack_public_path__ + "static/media/logoroi.6c926d3898db3143fd9092c64ed17781.svg";
export { ForwardRef as ReactComponent };